<header #pageHeader class="fixed-top">
  <nav>
    <img src="../../../assets/img/velmaral-banner.jpg" class="img-fluid header-img" alt="Event"
      (load)="onHeaderImageLoad()" decoding="async" />
  </nav>
</header>
<div class="bg-wrapper" #bgWrapper>
  <div class="container-fluid" *ngIf="!canShow">

    <div class="row mt-3 mb-3">
      <p class="limited-seat text-center mt-2 mb-2">
        வேல்மாறல் வழிபாட்டு பதிவுக்கு இன்னும் <b>{{remainingCount}} இடங்கள்</b> மட்டுமே உள்ளன.
      </p>
    </div>

    <!-- Background -->
    <div class="d-flex justify-content-center py-4 px-2">

      <!-- White Card Container -->
      <div class="container form-card p-4">

        <div class="instruction-box p-3 my-3">
          <div class="text-center">
            <h4 class="mb-3 text-color">ஊர் (City): {{eventDetails?.city}}</h4>
            <h4 class="mb-3 text-color">தேதி (Date): {{eventDetails?.eventDate | date: 'dd/MM/yyyy' }}</h4>
            <h4 class="mb-3 text-color">இடம் (venue): {{eventDetails?.eventVenue}}</h4>
          </div>
        </div>

        <form [formGroup]="eventForm" (ngSubmit)="submitForm()" class="p-2">

          <!-- ======= NO PAYMENT WARNING CHECKBOX ======= -->
          <div class="mb-3">
            <h6 class="font-weight-bolder d-block text-danger">கீழே உள்ள தேர்வுப்பெட்டியை உறுதிப்படுத்தி,
              நிகழ்விற்கான உங்கள் விவரங்களை உள்ளிட தொடர்ந்து செயல்படவும். (Kindly check the checkbox and proceed to
              enter your details.)</h6>

            <div class="form-check">
              <input type="checkbox" class="form-check-input" id="noScam" formControlName="noScam">
              <label class="form-check-label fw-bold" for="noScam">யாரிடமும் பணம் செலுத்தி ஏமாற மாட்டேன்</label>
            </div>

            <div *ngIf="eventForm.get('noScam')?.touched && eventForm.get('noScam')?.invalid" class="text-error mt-1">
              இந்த பொட்டியை டிக் செய்ய வேண்டும்.
            </div>
          </div>

          <div>
            <!-- ====== EMAIL ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">Email *</label>
              <input type="email" class="form-control" formControlName="emailId" placeholder="Enter valid email"
                [ngClass]="{'is-invalid': eventForm.get('emailId')?.touched && eventForm.get('emailId')?.invalid}">

              <div *ngIf="eventForm.get('emailId')?.touched && eventForm.get('emailId')?.invalid"
                class="text-error mt-1">
                சரியான Email ஐ உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== NAME ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">பெயர் (Name) *</label>
              <input type="text" class="form-control" formControlName="name"
                [ngClass]="{'is-invalid': eventForm.get('name')?.touched && eventForm.get('name')?.invalid}">

              <div *ngIf="eventForm.get('name')?.touched && eventForm.get('name')?.invalid" class="text-error mt-1">
                பெயர் அவசியம் தேவை.
              </div>
            </div>


            <!-- PHONE -->
            <div class="mb-3">
              <label class="form-label fw-bold">தொலைபேசி எண் (Contact Phone Number) *</label>

              <input type="text" class="form-control" formControlName="phoneNumber" maxlength="10"
                (input)="allowOnlyNumbers($event)"
                [ngClass]="{'is-invalid': eventForm.get('phoneNumber')?.touched && eventForm.get('phoneNumber')?.invalid}" />

              <div *ngIf="eventForm.get('phoneNumber')?.touched && eventForm.get('phoneNumber')?.invalid"
                class="text-error mt-1">
                <span *ngIf="eventForm.get('phoneNumber')?.errors?.['required']">தொலைபேசி எண்ணை உள்ளிடவும்.</span>
                <span *ngIf="eventForm.get('phoneNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை உள்ளிடவும்.</span>
              </div>
            </div>


            <!-- WHATSAPP -->
            <div class="mb-3">
              <label class="form-label fw-bold">வாட்ஸ் ஆப் எண் (WhatsApp Number) *</label>

              <input type="text" class="form-control" formControlName="whatsappNumber" maxlength="10"
                (input)="allowOnlyNumbers($event)"
                [ngClass]="{'is-invalid': eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid}" />

              <div *ngIf="eventForm.get('whatsappNumber')?.touched && eventForm.get('whatsappNumber')?.invalid"
                class="text-error mt-1">
                <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['required']">வாட்ஸ்அப் எண்ணை உள்ளிடவும்.</span>
                <span *ngIf="eventForm.get('whatsappNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை
                  உள்ளிடவும்.</span>
              </div>
            </div>

            <div class="mb-3">
              <label class="form-label fw-bold">மாநிலம் / யூ பிரதேசம் (State / UT) *</label>

              <br>

              <select class="form-select form-select-lg p-1" formControlName="state">
                <option value="" disabled selected>Select any one</option>
                <option *ngFor="let s of statesList" [value]="s.value">
                  {{ s.label }}
                </option>
              </select>


              <div *ngIf="eventForm.get('state')?.touched && eventForm.get('state')?.invalid" class="text-error mt-1">
                மாநிலம் / யூ பிரதேசத்தை உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== DISTRICT ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">மாவட்டம் (District) *</label>

              <br>
              <select class="form-select form-select-lg p-1" formControlName="district">
                <option value="" disabled selected>Select any one</option>

                <option *ngFor="let d of districtList" [value]="d.value">
                  {{ d.label }}
                </option>
              </select>

              <div *ngIf="eventForm.get('district')?.touched && eventForm.get('district')?.invalid"
                class="text-error mt-1">
                மாவட்டத்தை உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== ADDRESS ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">முகவரி (Address) *</label>
              <textarea rows="2" class="form-control" formControlName="address"
                [ngClass]="{'is-invalid': eventForm.get('address')?.touched && eventForm.get('address')?.invalid}"></textarea>

              <div *ngIf="eventForm.get('address')?.touched && eventForm.get('address')?.invalid"
                class="text-error mt-1">
                முகவரி தேவை.
              </div>
            </div>


            <!-- ====== AGE ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">வயது (Age) *</label>
              <input type="number" class="form-control" formControlName="age">

              <div *ngIf="eventForm.get('age')?.touched && eventForm.get('age')?.invalid" class="text-error mt-1">
                வயதை உள்ளிடவும்.
              </div>
            </div>


            <!-- ====== PHYSICALLY CHALLENGED ====== -->
            <div class="mb-3">
              <label class="form-label fw-bold">உடல் ஊனமுற்றவரா? (Physically challenged) *</label>

              <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="physically" value="Yes" id="phyYes">
                <label class="form-check-label" for="phyYes">Yes</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="radio" formControlName="physically" value="No" id="phyNo">
                <label class="form-check-label" for="phyNo">No</label>
              </div>

              <div *ngIf="eventForm.get('physically')?.touched && eventForm.get('physically')?.invalid"
                class="text-error mt-1">
                தயவுசெய்து ஒரு விருப்பத்தைத் தேர்வு செய்யவும்.
              </div>
            </div>


            <!-- ====== MAT CARRY RULE ====== -->
            <div class="instruction-box p-3 my-3">
              <p class="fw-bold mb-2">நிகழ்ச்சிக்கு வரும் பொழுது கண்டிப்பாக கீழே விரித்து அமர பாய் அல்லது துண்டு கொண்டு
                வர
                வேண்டும்.</p>
              <p class="fw-bold mb-2">கண்டிப்பாக தரையில் அமர்ந்து பூஜை செய்ய அனுமதி இல்லை.</p>

              <p class="fw-bold mb-2">When attending the event, it is mandatory to bring a mat, cloth, or any
                covering.</p>
              <p class="fw-bold mb-2">Sitting directly on the floor will not be allowed.</p>
            </div>


            <!-- ====== OPTIONAL CHECKBOX ====== -->
            <div class="mb-3">
              <div class="form-check">
                <input type="checkbox" class="form-check-input" id="willBring" formControlName="willBring">
                <label class="form-check-label" for="willBring">கண்டிப்பாக கொண்டு வருவேன்</label>
              </div>
            </div>


            <!--&lt;!&ndash; ====== WILL ATTEND RADIO ====== &ndash;&gt;
            <div class="mb-3">
              <label class="form-label fw-bold d-block">
                இந்த நிகழ்ச்சிக்கு கண்டிப்பாக நான் கலந்து கொள்வேன்.<br>
                வர முடியாத சூழ்நிலையில் குழுவிற்கு முன்பே தெரிவிக்கவும்.<br><br>

                <span class="fw-bold">I will definitely attend this event.</span><br>
                If I am unable to come, I will inform the group in advance.
              </label>

              <div class="form-check">
                <input class="form-check-input" type="radio" id="attendYes" value="Yes" formControlName="willAttend">
                <label class="form-check-label" for="attendYes">கண்டிப்பாக வழிபாட்டில் கலந்து கொள்வேன்</label>
              </div>

              <div class="form-check">
                <input class="form-check-input" type="radio" id="attendNo" value="No" formControlName="willAttend">
                <label class="form-check-label" for="attendNo">இல்லை, என்னால் வர இயலாது</label>
              </div>

              <div *ngIf="eventForm.get('willAttend')?.touched && eventForm.get('willAttend')?.invalid"
                   class="text-error mt-1">
                தயவுசெய்து ஒரு விருப்பத்தைத் தேர்வு செய்யவும்.
              </div>
            </div>-->


            <!-- ====== PARTICIPANTS DROPDOWN ====== -->
            <div class="border p-2">
              <div class="mb-3 ">
                <label class="form-label fw-bold">உடன் வருபவர்களின் எண்ணிக்கை (Participants count)</label>
                <br>
                <select class="form-select form-select-lg p-1" formControlName="participants">
                  <option value="" disabled selected>Select the counts</option>

                  <option [ngValue]="0" [disabled]="0 > maxSelectable">0</option>
                  <option [ngValue]="1" [disabled]="1 > maxSelectable">1</option>
                  <option [ngValue]="2" [disabled]="2 > maxSelectable">2</option>
                  <option [ngValue]="3" [disabled]="3 > maxSelectable">3</option>
                </select>


              </div>


              <div formArrayName="participantInputs">

                <div *ngFor="let row of members.controls; let i = index" [formGroupName]="i" class="row mb-2">

                  <!-- Name -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">பெயர் (Name) * {{ i + 1 }}</label>

                    <input type="text" formControlName="participantName" class="form-control"
                      [ngClass]="{'is-invalid': row.get('participantName')?.touched && row.get('participantName')?.invalid}">

                    <div class="invalid-feedback"
                      *ngIf="row.get('participantName')?.touched && row.get('participantName')?.invalid">
                      <span *ngIf="row.get('participantName')?.errors?.['required']">பெயர் அவசியம் தேவை.</span>
                      <span *ngIf="row.get('participantName')?.errors?.['minlength']">குறைந்தது 3 எழுத்துகள்
                        தேவை.</span>
                    </div>
                  </div>

                  <!-- Phone -->
                  <div class="col-md-6 mb-2">
                    <label class="form-label">தொலைபேசி எண் (Contact Phone Number) {{ i + 1 }}</label>

                    <input type="text" formControlName="whatsappNumber" class="form-control"
                      (input)="allowOnlyNumbers($event)"
                      [ngClass]="{'is-invalid': row.get('whatsappNumber')?.touched && row.get('whatsappNumber')?.invalid}"
                      maxlength="10" minlength="10">

                    <div class="invalid-feedback"
                      *ngIf="row.get('whatsappNumber')?.touched && row.get('whatsappNumber')?.invalid">
                      <span *ngIf="row.get('whatsappNumber')?.errors?.['required']">தொலைபேசி எண்ணை உள்ளிடவும்.</span>
                      <span *ngIf="row.get('whatsappNumber')?.errors?.['pattern']">சரியான 10 இலக்க எண்ணை
                        உள்ளிடவும்.</span>
                    </div>
                  </div>

                </div>

              </div>

            </div>

            <!-- ====== SUBMIT BUTTON ====== -->
            <div class="text-center">
              <button class="btn btn-danger btn rounded-pill px-5 mt-3 ">Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>


<div class="closed-wrapper d-flex justify-content-center align-items-center overflow-y" #bgWrapper *ngIf="canShow">
  <div class="closed-card animate__animated animate__fadeIn">
    <div class="icon-circles mb-3">
      <i class="bi bi-x-circle-fill"></i>
    </div>

    <h3 class="tamil-title">பதிவு முடிந்துவிட்டது</h3>
    <h6 class="tamil-text">
      இந்த நிகழ்விற்கான பதிவு நிறைவடைந்துவிட்டது.<br>
      நிகழ்வு ஏற்பாட்டாளரைத் தொடர்பு கொள்ளவும்.
    </h6>

    <hr>

    <h4 class="eng-title">Form Closed</h4>
    <h6 class="eng-text">
      The form is no longer accepting responses.<br>
      please contact the event organizer.
    </h6>
  </div>
</div>


<!-- <footer class="real -footer mt-5 pt-2 pb-2">
  <div class="text-white py-3">
    <div class="container">
      <div class="row d-flex justify-content-between align-items-center text-center">
        <div class="col-lg-6"><p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href="" class="text-white text-decoration-none font-weight-bold">
          வேல் மாறல் சேவா அறக்கட்டளை.
        </a></p></div>
        <div class="col-lg-6 justify-content-between align-items-center text-center"><p
           class="mb-0">Designed &amp; Developed by <a
           href="https://cktechsoln.in/" target="_blank"
          class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd Madurai.</a></p></div>
      </div>
    </div>
  </div>

</footer> -->

<footer class="real-footer">
  <div class="text-white py-1">
    <div class="container-fluid">
      <div class="row d-flex justify-content-between align-items-center text-center">

        <div class="col-lg-4 col-md-6 col-12 mb-2">
          <p class="mb-0 josefin-sans-regular">© <b>{{ currentYear }}</b> All rights reserved to <a href=""
              class="text-white text-decoration-none font-weight-bold">
              வேல் மாறல் சேவா அறக்கட்டளை.
            </a></p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
          <p class="mb-0">Designed &amp; Developed by <a href="https://cktechsoln.in/" target="_blank"
              class="text-white text-decoration-none font-weight-bold">CKTech Solution Pvt Ltd Madurai.</a></p>
        </div>
        <div class="col-lg-4 col-md-6 col-12 mb-2 justify-content-between align-items-center text-center">
          <p class="mb-0"><a routerLink="/terms" target="_blank"
              class="text-white text-decoration-none font-weight-bold">Terms & Conditions</a> | <a routerLink="/privacy"
              target="_blank" class="text-white text-decoration-none font-weight-bold">Privacy</a></p>
        </div>
      </div>
    </div>
  </div>

</footer>